import * as React from "react";
import { Fragment } from "react";

const RightLabelFieldTemplate = (props: any) => {

  const {
    classNames,
    label,
    help,
    required,
    description,
    errors,
    children,
    uiSchema
  } = props;

  return (
    <div className={`p-field ${classNames}`}>
      <div className="flex items-center">
        <div>{children}</div>
        <div>
          <div className={`ml-2 text-xs font-medium ${uiSchema?.["ui:options"]?.["label"]?.["classNames"]}`}>
            {label}
            {required ? "*" : null}
          </div>
          {description}
        </div>
      </div>

      <>
        {errors.props.errors &&
          errors.props.errors.map((error: any, index: number) => (
            <Fragment key={index}>
              <small className="p-d-block p-error">{error}</small>
            </Fragment>
          ))}
      </>
      {help}
    </div>
  );
};

export default RightLabelFieldTemplate;
